import { useState } from "react";
import { Link, useSearchParams } from "react-router-dom";
import { Loader2 } from "lucide-react";
import { api, errMsg } from "@/lib/api";
import { AuthCard, Field, inputCls, submitCls } from "@/pages/Login";
import { PasswordStrength } from "@/components/PasswordStrength";

export default function ResetPassword() {
  const [params] = useSearchParams();
  const token = params.get("token") || "";
  const tenant = params.get("t") || "";
  const back = tenant ? `/login/${tenant}` : "/login";
  const [pwd, setPwd] = useState("");
  const [pwd2, setPwd2] = useState("");
  const [error, setError] = useState("");
  const [done, setDone] = useState(false);
  const [busy, setBusy] = useState(false);
  const submit = async (e) => {
    e.preventDefault(); setError("");
    if (pwd.length < 8) return setError("La password deve avere almeno 8 caratteri");
    if (pwd !== pwd2) return setError("Le due password non coincidono");
    setBusy(true);
    try { await api.post("/auth/reset-password", { token, password: pwd, tenant }); setDone(true); } catch (err) { setError(errMsg(err)); } finally { setBusy(false); }
  };
  return (
    <div className="relative grid min-h-screen place-items-center overflow-hidden bg-[#07090e] px-6 py-10" data-testid="reset-page">
      <div className="pointer-events-none absolute -left-40 -top-40 h-[520px] w-[520px] rounded-full bg-blue-600/25 blur-[120px]" />
      <div className="pointer-events-none absolute -bottom-40 right-0 h-[480px] w-[480px] rounded-full bg-emerald-500/20 blur-[130px]" />
      <div className="relative w-full">
        <div className="mb-8 flex justify-center"><div className="relative"><div className="absolute -inset-6 rounded-full bg-[radial-gradient(closest-side,rgba(255,255,255,0.9),transparent)] blur-lg" /><img src="/nouvelle-crm-logo.png" alt="Nouvelle CRM" className="relative h-24 w-auto" /></div></div>
        <AuthCard testId="reset-form">
          {done ? (
            <div data-testid="reset-success">
              <h2 className="font-heading text-2xl font-semibold text-white">Password aggiornata</h2>
              <p className="mt-2 text-sm text-slate-400">Ora puoi accedere con la nuova password.</p>
              <Link to={back} data-testid="reset-go-login" className={`${submitCls} mt-8`}>Vai all'accesso</Link>
            </div>
          ) : (
            <form onSubmit={submit}>
              <h2 className="font-heading text-2xl font-semibold text-white">Scegli una nuova password</h2>
              <p className="mt-1.5 text-sm text-slate-400">Almeno 8 caratteri.</p>
              {!token && <div className="mt-6 rounded-xl border border-red-500/30 bg-red-500/10 p-3.5 text-sm text-red-300">Link non valido: richiedine uno nuovo dalla pagina di accesso.</div>}
              <div className="mt-8 space-y-5">
                <Field id="new-pwd" label="Nuova password"><input id="new-pwd" type="password" autoComplete="new-password" data-testid="reset-password-input" className={inputCls} value={pwd} onChange={(e) => setPwd(e.target.value)} /><PasswordStrength value={pwd} dark /></Field>
                <Field id="new-pwd2" label="Ripeti password"><input id="new-pwd2" type="password" autoComplete="new-password" data-testid="reset-password-confirm-input" className={inputCls} value={pwd2} onChange={(e) => setPwd2(e.target.value)} /></Field>
                {error && <div data-testid="reset-error" className="rounded-xl border border-red-500/30 bg-red-500/10 p-3.5 text-sm text-red-300">{error}</div>}
                <button type="submit" disabled={busy || !token} data-testid="reset-submit-button" className={submitCls}>{busy ? <Loader2 className="h-4 w-4 animate-spin" /> : "Salva nuova password"}</button>
              </div>
              <Link to={back} className="mt-5 inline-block text-sm text-teal-400 hover:text-teal-300">← Torna all'accesso</Link>
            </form>
          )}
        </AuthCard>
      </div>
    </div>
  );
}
